const _customerCategoryApis = {
    getList: function () {
        return _axiosService.get(`/WebCustomerCate/GetList`);
    },
};
